import { useState } from 'react';

import { HOST_URL } from '@marketplace/common';

import { TAPIResponse } from '../../api.types';
import { API_ROUTES } from '../../constants';
import { TAPIDeveloperContext, TAPIFetchDeveloperContext } from './fetch-context.types'


export const useAPIFetchDeveloperContext = (): TAPIFetchDeveloperContext => {
  const [developerContext, setDeveloperContext] = useState<TAPIResponse>({
    data: null,
    loaded: undefined,
    loading: false,
    error: undefined,
  });

  const fetchDeveloperContext = async (token: string | null): Promise<TAPIDeveloperContext> => {
    let response = null;
    let data: TAPIDeveloperContext = null;

    if (!token) {
      return Promise.resolve(null);
    }

    setDeveloperContext((prevState: TAPIResponse) => ({
      ...prevState,
      loading: true,
    }))

    try {
      response = await fetch(`${API_ROUTES.DEVELOPERS}/context`, {
        method: 'GET',
        cache: 'no-cache',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      data = await response.json();

      setDeveloperContext((prevState: TAPIResponse) => ({
        ...prevState,
        loading: true,
        data
      }));

      return Promise.resolve(data);

    } catch (error) {
      setDeveloperContext((prevState) => ({
        ...prevState,
        loaded: false,
        data,
        error
      }))

      return Promise.reject(data);
    }
  }

  return {
    ...developerContext,
    fetchDeveloperContext,
  };
};
